import React, { useState, useEffect } from "react";
import moment from "moment";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  customStyles,
  extract_time,
  fetchAccountData,
  fetchHouseData,
  formatNumber,
} from "../../utils/data/essential";
import { CSVLink } from "react-csv";
import { billHeaders } from "../../utils/data/reportData";
import Locations from "../../Component/Locations";
import DisplayBillAccount from "../../Component/bills/DisplayBillAccount";
import DisplayBillHouseDetails from "../../Component/bills/DisplayBillHouseDetails";
const Bills = () => {
  const [showHouseDetails, setShowHouseDetails] = useState(false);
  const [billData, setBillData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [types, setTypes] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [dataToBeFiltered, setDataToBeFiltered] = useState([]);
  const [selectedType, setSelectedType] = useState();
  const [selectedStatus, setSelectedStatus] = useState();
  const [loading, setLoading] = useState(false);
  const [accountData, setAccountData] = useState([]);
  const [houseData, setHouseData] = useState([]);
  const [showAccounts, setShowAccounts] = useState(false);
  const [showSearchBox, setShowSearchBox] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [dataToSearchFrom, setDataToSearchFrom] = useState([]);

  let date = new Date(selectedMonth);
  let year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const monthAndYear = `${year}${month}`;
  const user = JSON.parse(localStorage.getItem("user"));
  const [locationId, setLocationId] = useState(user.location_id);

  const filterBillData = (type, status) => {
    if (type === "All" && status === "All") {
      setBillData(dataToBeFiltered);
    } else {
      const filteredData = dataToBeFiltered.filter((dt) => {
        return dt.type === type && dt.status === status;
      });
      setBillData(filteredData);
    }
  };

  const extractData = (data) => {
    const arr = [];
    let obj = {};
    data.forEach((dt) => {
      obj.id = dt.id;
      obj.bill_run = moment(dt.billRun.datetime).format("DD-MM-YYYY");
      obj.account = dt.accountId;
      obj.house = dt.houseId;
      obj.period = dt.period;
      obj.datetime = moment(dt.datetime).format("DD-MM-YYYY hh:mm:ss A");
      obj.amount = `${formatNumber(dt.amount)} RWF`;
      obj.status = dt.status.name;
      obj.type = dt.type.name;
      arr.push(obj);
      obj = {};
    });
    setBillData(arr);
    setDataToBeFiltered(arr);
    setDataToSearchFrom(arr);
  };
  useEffect(() => {
    const url = `${baseUrl}/bills/types`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setTypes(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    const url = `${baseUrl}/bills/statuses`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setStatuses(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const fetchBillsData = () => {
    setLoading(true);
    const url = `${baseUrl}/bills?locationId=${locationId}&period=${monthAndYear}`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);
        setShowSearchBox(true);
        extractData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSearch = () => {
    const newBillData = dataToSearchFrom.filter((data) =>
      data?.status?.toLowerCase().includes(keyword.toLowerCase())
    );
    if (newBillData) {
      setBillData(newBillData);
    }
  };
  useEffect(() => {
    handleSearch();
  }, [keyword]);

  const columns = [
    {
      name: "Id",
      cell: (row) => <div style={{ cursor: "pointer" }}>{row["id"]}</div>,
    },
    { name: "Bill Run", cell: (row) => row["bill_run"] },
    {
      name: "Account",
      cell: (row) => (
        <div
          onClick={() => {
            fetchAccountData(row.account, setAccountData, user);
            handleShowModal('accounts')
          }}
          style={{ cursor: "pointer" }}
        >
          {row["account"]}
        </div>
      ),
    },
    {
      name: "House",
      cell: (row) => (
        <div
          onClick={() => {
            fetchHouseData(row.house, setHouseData, user);
            handleShowModal('house')
          }}
          style={{ cursor: "pointer" }}
        >
          {row["house"]}
        </div>
      ),
    },
    { name: "Period", cell: (row) => row["period"] },
    { name: "Type", cell: (row) => row["type"] },
    { name: "Datetime", cell: (row) => row["datetime"] },
    { name: "Amount", cell: (row) => row["amount"] },
    { name: "Status", cell: (row) => row["status"] },
  ];
  const receiveDataFromLocations = (data) => setLocationId(data?.locationId);
  const handleShowModal = (type) => {
    if (type === 'house') {
      setShowHouseDetails(true)
    } else {
      setShowAccounts(true);
    }
  }
  const handleCloseModal = (type) => {
    if (type === "house") {
      setShowHouseDetails(false);
    } else {
      setShowAccounts(false);
    }
  };
  return (
    <div>
      <div className='d-flex justify-content-center mt-3'>
        <h3>Bills</h3>
      </div>
      <Locations sendDataToParent={receiveDataFromLocations} />
      <div
        className='d-flex flex-wrap justify-content-center mt-4 ml-5'
        style={{ gap: 10 }}
      >
        <div className='location-input date-picker-mobile'>
          <DatePicker
            selected={selectedMonth}
            onChange={(date) => setSelectedMonth(date)}
            dateFormat='MM/yyyy'
            showMonthYearPicker
            className='form-control input-select'
          />
        </div>
      </div>
      <div className='d-flex justify-content-center'>
        <Button
          onClick={fetchBillsData}
          style={{
            backgroundColor: "#124db1",
          }}
        >
          {loading ? "Loading..." : "Search"}
        </Button>
      </div>
      {showSearchBox && (
        <div
          className='bill-filter-container mr-3'
          style={{ marginBottom: billData.length === 0 ? 80 : "" }}
        >
          {/* <div style={{ width: "30%" }}>
            <input
              type='text'
              className='form-control quick-search'
              placeholder='Quick search by status'
              onChange={(e) => setKeyword(e.target.value)}
            />
          </div> */}
          <div className='bill-filter1'>
            <select
              className='form-control input-select'
              onChange={(e) => {
                setSelectedType(e.target.value);
                filterBillData(e.target.value, selectedStatus);
              }}
            >
              <option>All</option>
              {types?.map((el) => (
                <option key={el.id} disabled={!dataToBeFiltered.length > 0}>
                  {el.name}
                </option>
              ))}
            </select>
          </div>
          <div className='bill-filter2'>
            <select
              className='form-control input-select'
              onChange={(e) => {
                setSelectedStatus(e.target.value);
                filterBillData(selectedType, e.target.value);
              }}
            >
              <option>All</option>
              {statuses.map((el) => (
                <option
                  key={el.id}
                  disabled={
                    !dataToBeFiltered.length > 0 ||
                    selectedType?.toLowerCase() == "credit note" ||
                    selectedType?.toLowerCase() == "credit note cancelled bill"
                  }
                >
                  {el.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
      {billData.length > 0 && (
        <div className='d-flex justify-content-end mr-3'>
          <CSVLink
            data={billData}
            headers={billHeaders}
            filename={`bill_report_${extract_time()}`}
          >
            <button
              type='button'
              className='btn btn-primary housesTableFilterBtn'
              disabled={billData.length === 0}
              style={{
                backgroundColor: billData.length === 0 ? "#cbcbcb" : "#124db1",
                color: billData.length === 0 ? "#000" : "",
                cursor: billData.length === 0 ? "default" : "pointer",
              }}
            >
              Excel{" "}
              <i
                style={{ marginLeft: "1rem" }}
                className='fas fa-file-excel'
              ></i>
            </button>
          </CSVLink>
        </div>
      )}
      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={columns}
          data={billData}
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          striped
          noHeader
        />
      </div>
      <DisplayBillHouseDetails
        show={showHouseDetails}
        hide={() => handleCloseModal("house")}
        billData={houseData}
      />
      <DisplayBillAccount
        show={showAccounts}
        hide={() => handleCloseModal("accounts")}
        accountData={accountData}
      />
    </div>
  );
};

export default Bills;
